import React from 'react';
import { getPlatformAppUrl } from '../utils/accountLinking';
import { PLATFORMS } from '../utils/userIdentities';
import '../styles/authLoader.css';

const MESSENGER_PROVIDERS = ['telegram', 'max'];

const OpenInMessenger = () => {
  const urls = MESSENGER_PROVIDERS.map((provider) => ({
    provider,
    url: getPlatformAppUrl(provider),
  }));
  const hasAnyUrl = urls.some(({ url }) => Boolean(url));

  return (
    <div className="auth-loader-screen open-in-messenger-screen">
      <div className="auth-loader-cup-wrap" aria-hidden="true">
        <div className="auth-loader-cup">
          <div className="auth-loader-coffee" />
        </div>
        <div className="auth-loader-handle" />
      </div>

      <h1 className="auth-loader-title">Откройте приложение в мессенджере</h1>
      <p className="auth-loader-subtitle open-in-messenger-text">
        RCoffee работает только как мини-приложение в Telegram или MAX.
        Нажмите кнопку ниже, чтобы перейти в нужный мессенджер.
      </p>

      <div className="open-in-messenger-actions">
        {urls.map(({ provider, url }) => {
          const label = PLATFORMS[provider]?.label || provider;
          const buttonLabel = `Открыть в ${label}`;

          if (url) {
            return (
              <a
                key={provider}
                href={url}
                className="btn open-in-messenger-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                {buttonLabel}
              </a>
            );
          }

          return (
            <button
              key={provider}
              type="button"
              className="btn open-in-messenger-btn"
              disabled
            >
              {buttonLabel}
            </button>
          );
        })}
      </div>

      {!hasAnyUrl && (
        <p className="open-in-messenger-warning" role="status">
          Ссылки на мини-приложение пока не настроены. Обратитесь к администратору сервиса.
        </p>
      )}
    </div>
  );
};

export default OpenInMessenger;
